export default __webpack_public_path__ + "static/media/whatsappIcon.c4b8de73.png";